export default __webpack_public_path__ + "static/1775-ebb7f05f2060cb74418be13107e0e271.gif";